import { MDBAutocomplete, MDBSelect } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LocAddressSeach } from "../../../apiclients/streamsapi_bridge";
import { CANADA, USA } from "../../images";

function LocNineOOGeneral({
  register,
  setValue,
  getValues,
  errors,
  billingGroups,
  locationsList,
  stateList,
  watch,
  clearErrors,
}) {
  const { t, i18n } = useTranslation();
  const [addressReasults, setAddressReasults] = useState([]);
  const [isDisplay, setisDisplay] = useState(false);
  const allowAPI = useRef(true);
  const [isLoading, setIsLoading] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleSearchAddressChange(searchValue) {
    try {
      clearErrors("general.street_addr1");
      setValue("general.street_addr1", searchValue, { shouldDirty: true });
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      const newTimeout = setTimeout(() => {
        sendApIRequest(searchValue);
      }, 500);
      // Update the typingTimeout state with the new timeout
      setTypingTimeout(newTimeout);
    } catch (error) {
      console.log(`Error in handleSearchAddressChange :::: ${error}`);
    }
  }

  const sendApIRequest = async (searchValue) => {
    try {
      if (searchValue.trim() !== "" && allowAPI.current) {
        //if (searchValue.trim() !== "") {
        let update = {
          reqid: 84,
          search: searchValue,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        };
        setIsLoading(true);
        console.log("Request for the search :::::: " + JSON.stringify(update));
        const serverResponse = await LocAddressSeach(update);
        setIsLoading(false);
        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error("Network response was not ok");
        } else {
          const responseData = await serverResponse.json();
          console.log("Response Data:", JSON.stringify(responseData));
          let addressList = responseData?.message?.suggestions ?? [];
          setAddressReasults(addressList);
          if (addressList.length === 0) {
            setisDisplay(false);
          } else {
            setisDisplay(true);
          }
        }
      } else {
        allowAPI.current = true;
        setisDisplay(false);
      }
    } catch (error) {
      console.log(`Error in sendApIRequest for address search :::: ${error}`);
    }
  };

  function handleAddressSelect(address) {
    if (address.street_line) {
      // setaddressValue(address.street_line);
      setValue("general.street_addr1", address.street_line, {
        shouldDirty: true,
      });
    }
    if (address.secondary) {
      setValue("general.street_addr2", address.secondary, {
        shouldDirty: true,
      });
    } else {
      setValue("general.street_addr2", "", {
        shouldDirty: true,
      });
    }
    if (address.city) {
      setValue("general.city", address.city, { shouldDirty: true });
    }
    if (address.state) {
      const stateObj = stateList.find(
        (state) => state.statecode.trim() === address.state.trim()
      );
      console.log("stateObj :::::::: " + JSON.stringify(stateObj));
      if (stateObj) {
        setValue("general.state", parseInt(stateObj.stateid), {
          shouldDirty: true,
        });
      }
    }
    if (address.zipcode) {
      setValue("general.zip", address.zipcode, { shouldDirty: true });
    }
  }
  return (
    <>
      <div className="general-settings">{t("general")}</div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("name")}</div>
        <div className="d-flex flex-column align-items-start  w-30">
        <div className="d-flex w-100">
          <input
            type="text"
            maxLength={50}
            className="form-control selectname w-100"
            {...register("general.nineoo_loc_name",{required : "Name is required"})}
            />
        </div>
          {errors.general?.nineoo_loc_name && (
            <p className="text-danger text-left">
              {errors.general.nineoo_loc_name.message}
            </p>
          )}
          </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("Street Address 1")}</div>
        <div className="d-flex w-30">
          {/* <input
            type="text" placeholder="Address 1"
            className="form-control selectname"
            {...register("general.street_addr1")}
          /> */}
          <MDBAutocomplete
            data={addressReasults}
            // value={addressValue}
            value={watch("general.street_addr1")}
            displayValue={(address) => address.street_line}
            isLoading={isLoading}
            // open={isDisplay}
            placeholder="Address 1"
            onSearch={handleSearchAddressChange}
            onSelect={(address) => {
              allowAPI.current = false;
              setisDisplay(false);
              handleAddressSelect(address);
            }}
            itemContent={(address) => (
              <div
                onClick={(e) => {
                  e.preventDefault();
                  allowAPI.current = false;
                  handleAddressSelect(address);
                }}
              >
                {address.country && (
                  <img
                    src={address.country === "USA" ? USA : CANADA}
                    className="me-3"
                    width={25}
                  />
                )}
                {address.street_line || ""}
                {address.secondary ? ", " + address.secondary : ""}
                {address.city ? ", " + address.city : ""}
                {address.state ? ", " + address.state : ""}
                {address.zipcode ? ", " + address.zipcode : ""}
              </div>
            )}
          />
          {errors.general?.street_addr1 && (
            <p className="text-danger">{errors.general.street_addr1.message}</p>
          )}
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("Street Address 2")}</div>
        <div className="d-flex w-30">
          <input
            type="text"
            placeholder="Address 2"
            className="form-control selectname text-secondary"
            {...register("general.street_addr2")}
          />
          {errors.general?.street_addr2 && (
            <p className="text-danger">{errors.general.street_addr2.message}</p>
          )}
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("City")}</div>
        <div className="d-flex w-30">
          <input
            type="text"
            className="form-control selectname w-100"
            {...register("general.city")}
          />
          {errors.general?.state && (
            <p className="text-danger">{errors.general.state.message}</p>
          )}
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("State")}</div>
        <div className="d-flex w-30">
          <div className="form w-100">
            <MDBSelect
              className="w-100 m-0"
              data={locationsList}
              value={watch("general.state")}
              // defaultValue={getValues("general.state")}
              search
              onChange={(e) =>
                setValue("general.state", parseInt(e.value), {
                  shouldDirty: true,
                })
              }
            />
            {errors.general?.state && (
              <p className="text-danger">{errors.general.state.message}</p>
            )}
          </div>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("ZIPCode")}</div>
        <div className="d-flex w-30">
          <input
            type="text"
            className="form-control selectname w-100"
            {...register("general.zip")}
          />
          {errors.general?.zip && (
            <p className="text-danger">{errors.general.zip.message}</p>
          )}
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{t("Billing Group")}</div>
        <div className="phoneselect w-30">
          <MDBSelect
            className="w-100 m-0"
            data={billingGroups}
            value={watch("general.billing_grp")}
            search
            onChange={(e) => {
              console.log("e.value is ::: ", e.value);
              setValue("general.billing_grp", parseInt(e.value), {
                shouldDirty: true,
              });
            }}
          />
          {errors.general?.billing_grp && (
            <p className="text-danger">{errors.general.billing_grp.message}</p>
          )}
        </div>
      </div>
    </>
  );
}

export default LocNineOOGeneral;
